<template>
  <div>
    <v-dialog v-model="model" class="tw-max-w-[620px] tw-w-full tw-relative custom-estimate-modal">
      <v-card>
        <div class="tw-w-full tw-flex tw-justify-end tw-pr-3 sm:tw-hidden">
          <v-icon
            @click="$emit('toggleDialog')"
            size="18px"
            class="tw-ml-[2px] !tw-text-black tw-cursor-pointer"
            icon=" fa fa-close"
          ></v-icon>
        </div>
        <div class="tw-p-3 tw-bg-[#fafafa] tw-m-3">
          <div>
            <h2 class="tw-text-center tw-w-full tw-text-4xl tw-font-kanit tw-font-extralight">
              Estimate Monthly Payments
            </h2>
            <div class="tw-w-full tw-p-3 tw-text-center tw-bg-white tw-h-[60px] tw-mt-3">
              <p class="tw-text-2xl tw-font-bold tw-font-kanit">${{ monthlyPayment }}/mo</p>
            </div>
          </div>
          <p class="tw-text-xs tw-font-extralight tw-font-kanit tw-my-4">
            Only an estimate. Excludes taxes, title, license, and insurance.
          </p>
          <div class="tw-flex tw-flex-col tw-gap-6">
            <div class="tw-flex tw-flex-col tw-gap-1 tw-w-full">
              <p class="tw-font-kanit tw-text-xs tw-font-extralight">Price</p>
              <div class="tw-flex tw-gap-2 tw-items-center">
                <input
                  class="tw-font-open-sans custom-field tw-w-full tw-py-3 tw-px-4 focus:tw-outline-none focus:tw-ring focus:tw-border-blue-500 tw-transition-all tw-duration-100 hover:!tw-border-gray-900"
                  id="Price"
                  type="text"
                  :value="formattedPrice"
                  @input="updatePrice"
                  placeholder="$0"
                />
                <v-icon
                  @click="toggleInfoModal('price')"
                  size="18px"
                  class="tw-ml-[2px] !tw-text-[#c7c7c7] hover:!tw-text-black tw-cursor-pointer"
                  icon=" fa fa-info-circle"
                ></v-icon>
              </div>
            </div>
            <div class="tw-flex tw-flex-col tw-gap-1 tw-w-full">
              <p class="tw-font-kanit tw-text-xs tw-font-extralight">
                Down payment
                <v-icon
                  v-if="!downPaymentDetails"
                  @click="toggleDownPayment"
                  size="16px"
                  class="tw-ml-[2px] tw-mb-1 tw-cursor-pointer"
                  icon="fa fa-plus-circle"
                ></v-icon>
                <v-icon
                  v-if="downPaymentDetails"
                  @click="toggleDownPayment"
                  size="16px"
                  class="tw-ml-[2px] tw-mb-1 tw-cursor-pointer"
                  icon="fa fa-minus-circle"
                ></v-icon>
              </p>
              <div class="tw-flex tw-gap-2 tw-items-center">
                <input
                  class="tw-font-open-sans custom-field tw-w-full tw-py-3 tw-px-4 focus:tw-outline-none focus:tw-ring focus:tw-border-blue-500 tw-transition-all tw-duration-100 hover:!tw-border-gray-900 disabled:hover:!tw-border-[#e0e0e0] disabled:tw-cursor-not-allowed"
                  id="Price"
                  type="text"
                  :value="formattedDownPayment"
                  @blur="updateDownPaymentFormat"
                  placeholder="$0"
                  :disabled="downPaymentDetails"
                />
                <!-- @input="updateDownPayment($event.target.value)" -->
                <v-icon
                  @click="toggleInfoModal('down payment')"
                  size="18px"
                  class="tw-ml-[2px] !tw-text-[#c7c7c7] hover:!tw-text-black tw-cursor-pointer"
                  icon=" fa fa-info-circle"
                ></v-icon>
              </div>
              <div v-if="downPaymentDetails" class="tw-pl-4 tw-flex tw-flex-col tw-gap-3 tw-mt-2">
                <div class="tw-flex tw-flex-col tw-gap-1 tw-w-full">
                  <p class="tw-font-kanit tw-text-xs tw-font-extralight">Trade-in value</p>
                  <div class="tw-flex tw-gap-2 tw-items-center">
                    <input
                      class="tw-font-open-sans custom-field tw-w-full tw-py-3 tw-px-4 focus:tw-outline-none focus:tw-ring focus:tw-border-blue-500 tw-transition-all tw-duration-100 hover:!tw-border-gray-900"
                      id="Price"
                      type="text"
                      :value="formattedTradeInVal"
                      @blur="updateTradeIn($event.target.value)"
                      placeholder="$0"
                    />
                    <v-icon
                      @click="toggleInfoModal('Trade-in value')"
                      size="18px"
                      class="tw-ml-[2px] !tw-text-[#c7c7c7] hover:!tw-text-black tw-cursor-pointer"
                      icon=" fa fa-info-circle"
                    ></v-icon>
                  </div>
                </div>
                <div class="tw-flex tw-flex-col tw-gap-1 tw-w-full">
                  <p class="tw-font-kanit tw-text-xs tw-font-extralight">Payoff amount</p>
                  <div class="tw-flex tw-gap-2 tw-items-center">
                    <input
                      class="tw-font-open-sans custom-field tw-w-full tw-py-3 tw-px-4 focus:tw-outline-none focus:tw-ring focus:tw-border-blue-500 tw-transition-all tw-duration-100 hover:!tw-border-gray-900"
                      id="Price"
                      type="text"
                      :value="formattedPayoff"
                      @blur="updatePayoffAmount($event.target.value)"
                      placeholder="$0"
                    />
                    <v-icon
                      @click="toggleInfoModal('Payoff amount')"
                      size="18px"
                      class="tw-ml-[2px] !tw-text-[#c7c7c7] hover:!tw-text-black tw-cursor-pointer"
                      icon=" fa fa-info-circle"
                    ></v-icon>
                  </div>
                </div>
                <div class="tw-flex tw-flex-col tw-gap-1 tw-w-full">
                  <p class="tw-font-kanit tw-text-xs tw-font-extralight">Additional down payment</p>
                  <div class="tw-flex tw-gap-2 tw-items-center">
                    <input
                      class="tw-font-open-sans custom-field tw-w-full tw-py-3 tw-px-4 focus:tw-outline-none focus:tw-ring focus:tw-border-blue-500 tw-transition-all tw-duration-100 hover:!tw-border-gray-900"
                      id="Price"
                      type="text"
                      :value="formattedAdditionalDP"
                      @blur="updateAdditionalDP($event.target.value)"
                      placeholder="$0"
                    />
                    <v-icon
                      @click="toggleInfoModal('Additional down payment')"
                      size="18px"
                      class="tw-ml-[2px] !tw-text-[#c7c7c7] hover:!tw-text-black tw-cursor-pointer"
                      icon=" fa fa-info-circle"
                    ></v-icon>
                  </div>
                </div>
              </div>
            </div>
            <div class="tw-flex tw-flex-col tw-gap-1 tw-w-full">
              <p class="tw-font-kanit tw-text-xs tw-font-extralight">Term</p>
              <div class="tw-flex tw-gap-2 tw-items-center">
                <v-select
                  label=""
                  class="custom-select-field tw-font-open-sans hover:!tw-border-gray-900"
                  :items="termsOptions"
                  item-value="value"
                  item-title="label"
                  variant="outlined"
                  v-model="loanTermMonths"
                ></v-select>
                <div class="tw-flex tw-items-center tw-mb-5">
                  <v-icon
                    @click="toggleInfoModal('terms')"
                    size="18px"
                    class="tw-ml-[2px] !tw-text-[#c7c7c7] hover:!tw-text-black tw-cursor-pointer"
                    icon=" fa fa-info-circle"
                  ></v-icon>
                </div>
              </div>
              <div class="tw-flex tw-gap-2 tw-items-center">
                <p class="tw-font-kanit tw-text-xs tw-font-extralight">Finance rate (APR)</p>
                <v-icon
                  @click="toggleInfoModal('finance rate')"
                  size="18px"
                  class="tw-ml-[2px] !tw-text-[#c7c7c7] hover:!tw-text-black tw-cursor-pointer"
                  icon=" fa fa-info-circle"
                ></v-icon>
              </div>
              <div class="tw-mt-3">
                <v-radio-group v-model="selectedRate">
                  <div
                    class="tw-flex tw-w-full tw-flex-wrap md:tw-flex-nowrap tw-justify-between tw-items-start"
                  >
                    <div class="tw-w-full md:tw-mr-10">
                      <v-radio
                        density="compact"
                        :ripple="false"
                        class="custom-radio"
                        :label="
                          selectedRate === 'based of estimated rate'
                            ? `Rate Based On Estimated Credit Score: ${annualInterestRate}%`
                            : `Rate Based On Estimated Credit Score: 0`
                        "
                        value="based of estimated rate"
                      ></v-radio>
                      <v-select
                        :disabled="selectedRate != 'based of estimated rate'"
                        label=""
                        class="custom-select-field tw-mt-2 tw-font-open-sans hover:!tw-border-gray-900"
                        :items="[
                          'Staller',
                          'Awesome',
                          'Good',
                          'Ok',
                          'Not perfect',
                          'Need improvements',
                        ]"
                        variant="outlined"
                        v-model="estimatedCreditScore"
                      ></v-select>
                    </div>
                    <div class="tw-w-full">
                      <v-radio
                        density="compact"
                        :ripple="false"
                        class="custom-radio"
                        label="Custom rate"
                        value="custom rate"
                      ></v-radio>
                      <input
                        :disabled="selectedRate != 'custom rate'"
                        class="tw-font-open-sans tw-mt-2 custom-field tw-w-full tw-py-3 tw-px-4 focus:tw-outline-none disabled:hover:!tw-border-[#e0e0e0] disabled:tw-cursor-not-allowed focus:tw-ring focus:tw-border-blue-500 tw-transition-all tw-duration-100 hover:!tw-border-gray-900"
                        id="Custom rate"
                        type="text"
                        :value="formattedCustomRate"
                        @blur="updateAnnualRate"
                        placeholder="Enter Rate"
                      />
                    </div>
                  </div>
                </v-radio-group>
              </div>
              <div
                class="tw-w-full tw-pb-1 tw-text-center tw-font-kanit tw-text-sm tw-font-light tw-cursor-pointer"
                @click="setTerms"
              >
                Set terms
              </div>
            </div>
          </div>
          <InfoDialog
            @toggle-info-dialog="toggleInfoModal(selectedInfo)"
            v-model="infoModal"
            :infoDetails="infoDetails"
            :infoHeading="infoHeading"
          />
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import InfoDialog from './InfoDialog.vue';
import { useCarsStore } from '@/stores/useCarsStore';
import { storeToRefs } from 'pinia';
import { useLoanStore } from '@/stores/useLoadStore';

const model = defineModel();
const props = defineProps(['carDetails']);
const emits = defineEmits(['toggleDialog']);

const carStore = useCarsStore();
const loanStore = useLoanStore();

const {
  monthlyPayment,
  downPayment,
  loanTermMonths,
  annualInterestRate,
  selectedRate,
  estimatedCreditScore,
  customRate,
} = storeToRefs(loanStore);
const { paymentDetails } = storeToRefs(carStore);
const { calculateLoan } = loanStore;

const termsOptions = [
  { value: 36, label: '36 Months' },
  { value: 42, label: '42 Months' },
  { value: 48, label: '48 Months' },
  { value: 60, label: '60 Months' },
];

const additionalDP = ref(0);
const payoffAmount = ref(0);
const tradeInVal = ref(0);
const infoModal = ref(false);
const selectedInfo = ref('');
const downPaymentDetails = ref(false);

const price = ref(props.carDetails?.totalMSRP || 0);

const formattedPrice = computed(() => {
  if (!price.value) return '';
  return `$${Number(price.value).toLocaleString()}`;
});
const formattedCustomRate = computed(() => {
  const rate =
    customRate.value ??
    (selectedRate.value === 'custom rate' ? annualInterestRate.value : null);
  if (rate == null || Number.isNaN(Number(rate))) return '';
  return `${Number(rate).toLocaleString()}%`;
});

const formattedDownPayment = computed(() => {
  if (!downPayment.value) return '';
  return `$${Number(downPayment.value).toLocaleString()}`;
});

const formattedTradeInVal = computed(() => {
  if (!tradeInVal.value) return '';
  return `$${Number(tradeInVal.value).toLocaleString()}`;
});
const formattedPayoff = computed(() => {
  if (!payoffAmount.value) return '';
  return `$${Number(payoffAmount.value).toLocaleString()}`;
});

const formattedAdditionalDP = computed(() => {
  if (!additionalDP.value) return '';
  return `$${Number(additionalDP.value).toLocaleString()}`;
});

const infoDetails = computed(() => {
  if (selectedInfo.value === 'price') {
    return 'The total cost of the vehicle.';
  }
  if (selectedInfo.value === 'down payment') {
    return 'A down payment is an initial, upfront payment you make toward the total cost of the vehicle. Your down payment could be cash, the value of a trade-in, or both. The more you put down, the less you need to borrow. A larger down payment may also reduce your monthly payment and your total cost of financing.';
  }
  if (selectedInfo.value === 'finance rate') {
    return 'This is the annual percentage rate, and is not always the same as the interest rate. This represents the annual rate that is charged, and as such, is the actual annual cost to the consumer over the course of the auto loan. The APR will allow you to more easily shop and compare car loans, since it equates all loans to the same annual rate.';
  }
  if (selectedInfo.value === 'terms') {
    return 'This is the length of your auto loan, generally expressed in months. A shorter loan term (in which you make monthly payments for fewer months) will reduce your total loan cost. A longer loan can reduce your monthly payment, but you pay more interest over the life of the loan. A longer loan also puts you at risk for negative equity, which is when you owe more on the vehicle than the vehicle is worth.';
  }
  if (selectedInfo.value === 'Trade-in value') {
    return 'The trade in value is the amount that a dealer is willing to offer you towards the purchase of a new vehicle in exchange for your current one. It’s typically based on the market value of your vehicle (the amount it would sell for on the open market).';
  }
  if (selectedInfo.value === 'Payoff amount') {
    return 'Your payoff amount is how much you will actually have to pay to satisfy the terms of your mortgage loan and completely pay off your debt. Your payoff amount is different from your current balance.';
  }
  if (selectedInfo.value === 'Additional down payment') {
    return 'Additional down payment in cash.';
  }
  return '';
});
const infoHeading = computed(() => {
  if (selectedInfo.value === 'price') {
    return 'Price';
  }
  if (selectedInfo.value === 'down payment') {
    return 'Down Payment';
  }
  if (selectedInfo.value === 'finance rate') {
    return 'Finance Rate (APR)';
  }
  if (selectedInfo.value === 'terms') {
    return 'Loan Terms';
  }
  if (selectedInfo.value === 'Trade-in value') {
    return 'Trade-in value';
  }
  if (selectedInfo.value === 'Payoff amount') {
    return 'Payoff amount';
  }
  if (selectedInfo.value === 'Additional down payment') {
    return 'Additional down payment';
  }
  return '';
});

const updateAnnualRate = (event) => {
  const rawValue = event.target.value.replace(/[^\d.]/g, '');
  const rate = rawValue === '' ? null : Number(rawValue);
  customRate.value = rate;
  if (rate != null) {
    annualInterestRate.value = rate;
  }
};

const applyEstimatedRate = (val = estimatedCreditScore.value) => {
  if (selectedRate.value !== 'based of estimated rate') return;
  updateAnnualRateOnCondition(val);
};

const restoreCustomRate = () => {
  if (customRate.value != null) {
    annualInterestRate.value = Number(customRate.value);
  }
};

const updateDownPaymentFormat = (event) => {
  const rawValue = event.target.value.replace(/[^\d.]/g, '');
  downPayment.value = rawValue;
  tradeInVal.value = rawValue;
  downPayment.value = rawValue;
};
const updatePrice = (event) => {
  const rawValue = event.target.value.replace(/[^\d.]/g, '');
  price.value = rawValue;
};
const toggleDownPayment = () => {
  downPaymentDetails.value = !downPaymentDetails.value;
  if (downPaymentDetails.value) {
    tradeInVal.value = downPayment.value;
  }
};

const updateAnnualRateOnCondition = (val) => {
  switch (val) {
    case 'Need improvements':
      annualInterestRate.value = 18.45;
      break;
    case 'Not perfect':
      annualInterestRate.value = 15.29;
      break;
    case 'Ok':
      annualInterestRate.value = 12.61;
      break;
    case 'Good':
      annualInterestRate.value = 9.41;
      break;
    case 'Awesome':
      annualInterestRate.value = 6.64;
      break;
    case 'Staller':
      annualInterestRate.value = 5.71;
      break;

    default:
      break;
  }
};

const setTerms = () => {
  calculateLoan(
    Number(price.value),
    Number(downPayment.value),
    Number(annualInterestRate.value),
    Number(loanTermMonths.value),
  );
  paymentDetails.value = {
    monthlyPaymentVal: Math.round(monthlyPayment.value),
    cashDown: Number(downPayment.value).toLocaleString(),
    totalMonths: loanTermMonths.value,
  };
  emits('toggleDialog');
};

const updateTradeIn = (val) => {
  const rawValue = val.replace(/[^\d.]/g, '');
  tradeInVal.value = rawValue;
  downPayment.value = rawValue;
  if (payoffAmount.value || additionalDP.value) {
    downPayment.value =
      Number(tradeInVal.value) - Number(payoffAmount.value) + Number(additionalDP.value);
  }
};

const updatePayoffAmount = (val) => {
  const rawValue = val.replace(/[^\d.]/g, '');
  payoffAmount.value = rawValue;
  downPayment.value = Number(tradeInVal.value) - rawValue + Number(additionalDP.value);
};
const updateAdditionalDP = (val) => {
  const rawValue = val.replace(/[^\d.]/g, '');
  additionalDP.value = rawValue;
  downPayment.value = Number(tradeInVal.value) + Number(rawValue) - Number(payoffAmount.value);
};

const toggleInfoModal = (selected) => {
  selectedInfo.value = selected;
  infoModal.value = !infoModal.value;
};

watch(
  () => props.carDetails?.totalMSRP,
  (newVal) => {
    if (newVal != null) {
      price.value = newVal;
    }
  },
);

watch(selectedRate, (newVal) => {
  if (newVal === 'based of estimated rate') {
    applyEstimatedRate();
  } else if (newVal === 'custom rate') {
    restoreCustomRate();
  }
});

watch(
  estimatedCreditScore,
  (newVal) => {
    applyEstimatedRate(newVal);
  },
  { immediate: true },
);

watch(
  [downPayment, annualInterestRate, loanTermMonths, price],
  () => {
    calculateLoan(
      Number(price.value),
      Number(downPayment.value),
      Number(annualInterestRate.value),
      Number(loanTermMonths.value),
    );
    loanStore.$patch({
      monthlyPayment: Math.round(monthlyPayment.value),
    });

    const termsAlreadySet =
      Number(paymentDetails.value?.totalMonths) > 0 ||
      Number(paymentDetails.value?.monthlyPaymentVal) > 0;
    if (termsAlreadySet) {
      paymentDetails.value = {
        monthlyPaymentVal: Math.round(monthlyPayment.value),
        cashDown: Number(downPayment.value).toLocaleString(),
        totalMonths: loanTermMonths.value,
      };
    }
  },
  { immediate: true },
);
</script>
<style>
.custom-field {
  border: 1px solid #e0e0e0 !important;
  height: 42px;
  border-radius: 8px;
}
.custom-select-field .v-field {
  @apply tw-flex tw-items-center tw-font-open-sans custom-field tw-w-full !tw-border-none tw-shadow-none focus:!tw-ring focus:!tw-border-blue-500 tw-transition-all tw-duration-100;
}
.custom-select-field .v-field__outline {
  @apply !tw-text-[#c7c7c7] hover:!tw-text-black;
}
.custom-radio .v-label {
  @apply !tw-text-[13px] !tw-text-black tw-font-kanit !tw-font-extralight !tw-text-nowrap;
}
.custom-radio .v-icon {
  @apply !tw-text-xl !tw-mt-[2px] !tw-mr-1;
}
.custom-estimate-modal .v-overlay__scrim {
  @apply !tw-bg-white !tw-opacity-100 sm:!tw-bg-black sm:!tw-opacity-30;
}
.custom-estimate-modal .v-card {
  @apply !tw-shadow-none;
}
</style>
